class ProductModal extends ModalDialog {
  constructor() {
    super();

     /* video controls */
    const productMedia = this.querySelector('.product__media-item');
    const controlButton = this.querySelector('.js-product__video-control');

    let videoPaused = true;

    if(controlButton) {
      controlButton.addEventListener('click', () => {
        const video = this.querySelector('.js-product-video');

        if(video) {
          if (!videoPaused) {
            video.pause();
            controlButton.classList.add('paused');
            controlButton.classList.remove('playing');
            videoPaused = true;
          } else {
            video.play();
            controlButton.classList.remove('paused');
            controlButton.classList.add('playing');
            videoPaused = false;
          }
        } else { // on first load...
          videoPaused = false;
          controlButton.classList.add('playing');
        }
      });
    }
    /* /end video controls */
  }

  hide() {
    super.hide();
  }

  show(opener) {
    super.show(opener);
    this.showActiveMedia();
  }

  showActiveMedia() {
    this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
        element.classList.remove('active');
      }
    )
    const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
    const activeMediaTemplate = activeMedia.querySelector('template');
    const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
    activeMedia.classList.add('active');
    activeMedia.scrollIntoView();

    const container = this.querySelector('[role="document"]');
    container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

    if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
      activeMedia.loadContent();
  }
}

if(!customElements.get('product-modal')) {
  customElements.define('product-modal', ProductModal);
}